import React from 'react';
import styled from '@emotion/styled';
import { colors, typography, } from '@argo/principles';
import { Rating, } from '@argo/ui-elements';


export const ConsumerRatingsHeading = styled.div<any>`
`;

export const Description = styled.div<any>`
  font-size: 10px;
  line-height: 13px;
  font-family: ${typography.family.opensans};
  color: ${colors.primary.charcoal};
  font-weight: ${typography.weight.regular};
  text-align: left;
`;

const ConsumerRatings = ({ vehicle, consumerReviewAndRating, }: any,) => {
  const { numberOfReviews, } = consumerReviewAndRating;
  const { generationStartYear, generationEndYear, } = vehicle;
  const description = `Based on ${numberOfReviews} consumer ratings for the ${generationStartYear} – ${generationEndYear} models.`;
  let showDescription = true;

  if (!numberOfReviews || !generationStartYear || !generationEndYear) {
    showDescription = false;
  }

  return (
    <div id="consumer-ratings-heading">
      <ConsumerRatingsHeading>
        <Rating rating={consumerReviewAndRating.consumerRating.overallRating} text="KBB.com Consumer Ratings" size="Medium"/>
        <Description id="consumer-rating-description" style={{ display: showDescription ? 'block' : 'none', }}>
          {description}
        </Description>
      </ConsumerRatingsHeading>
    </div>
  );
};

export default ConsumerRatings;
